import { Session } from '@ais-ui/auth';

type CheckQueueStatusResult = {
  errorMessage: string;
  percentComplete: number;
  status: 'QueueRunning' | 'QueueComplete' | 'QueueFailed';
};

export type ExportFormat =
  | 'OF_CSV'
  | 'OF_PDF'
  | 'OF_EXCEL'
  | 'OF_ZIP'
  | 'OF_ESRI_SHAPES'
  | 'OF_ESRI_RASTER'
  | 'OF_SHIPLIST'
  | 'OF_VIDEO'
  | 'OF_CSV_TRACK';

export const startQueryingReportExportResult = async (
  session: Session,
  jobId: string,
  format: ExportFormat,
  centerLat: number,
  centerLon: number,
  zoomLevel: number,
  minLat: number,
  minLon: number,
  maxLat: number,
  maxLon: number,
  timeZone: string,
): Promise<string> => {
  const response: string = await session.request('queueJobOutput', {
    jobUuid: jobId,
    format: format,
    sortColumn: '',
    sortAscending: true,
    centerLat: centerLat,
    centerLon: centerLon,
    zoomLevel: zoomLevel,
    minLat: minLat,
    minLon: minLon,
    maxLat: maxLat,
    maxLon: maxLon,
    mapType: 'OSM',
    flags: 'includeExtraData',
    serverUid: 'd4bd4710-1765-4476-8969-09ab9d0b676f',
    timeZone: timeZone,
  });
  return response;
};

export const startQueryingReportExportResultShipList = async (
  session: Session,
  jobId: string,
): Promise<string> => {
  const response: string = await session.request('queueJobResultShiplist', {
    jobUuid: jobId,
  });
  return response;
};

export const getReportExportQueueStatus = async (
  session: Session,
  queueId: string,
): Promise<CheckQueueStatusResult> => {
  const response: CheckQueueStatusResult = await session.request(
    'getQueueStatus',
    {
      queueUuid: queueId,
    },
  );

  return response;
};

export const getReportExportResult = async (
  session: Session,
  queueId: string,
): Promise<string> => {
  const response: string = await session.request('getJobOutputUrl', {
    queueUuid: queueId,
  });

  return response;
};

export const getReportExportResultShipList = async (
  session: Session,
  queueId: string,
): Promise<string> => {
  const response: string = await session.request('getJobResultShiplist', {
    queueUuid: queueId,
  });
  return response;
};
